import script from "./ViewLifecycle.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLifecycle.vue?vue&type=script&setup=true&lang=js"

import "./ViewLifecycle.vue?vue&type=style&index=0&id=2c21ea44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c21ea44"]])

export default __exports__